import styled from "styled-components/macro";
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1.6rem 0 1.6rem;
  background: rgba(239, 236, 232, 0.66);
  @media (min-width: 992px) {
    flex-direction: row;
    padding: 4rem 8rem 4rem 7.7rem;
  }
`;

export const Img = styled.img`
  width: 352px;
  opacity: ${({ scroll }) => (scroll > 400 ? "1" : "0")};
  transition: opacity 0.7s ease-in-out;
  @media (min-width: 992px) {
    width: 500px;
    opacity: ${({ scroll }) => (scroll > 600 ? "1" : "0")};
  }
`;

export const ContainerIcon = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: start;
  margin-bottom: 2rem;
`;

export const IconContainer = styled.div`
  margin-right: 1rem;
`;
export const ContainerTextIcon = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  h4 {
    margin: 0 0 0.5rem 0;
    font-family: "Rubik";
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    text-align: start;
    color: #000000;
  }

  @media (min-width: 992px) {
    h4 {
      font-size: 16px;
      line-height: 18px;
    }
  }
`;

export const TextIcon = styled.p`
  margin: 0;
  padding-right: 0.5rem;
  font-family: "Rubik";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  text-align: start;
  color: #000000;
  transform: ${({ scroll }) =>
    scroll > 1050 ? "translateY(0)" : "translateY(1rem)"};
  opacity: ${({ scroll }) => (scroll > 1050 ? "1" : "0")};
  transition: transform 0.5s, opacity 0.6s ease-in-out;
  @media (min-width: 992px) {
    font-size: 16px;
    line-height: 20px;
    transform: ${({ scroll }) =>
      scroll > 600 ? "translateY(0)" : "translateY(1rem)"};
    opacity: ${({ scroll }) => (scroll > 600 ? "1" : "0")};
  }
`;

export const ContainerText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  padding: 2rem 0;

  @media (min-width: 992px) {
    padding: 0;
    margin-left: 3rem;
    padding-bottom: 1.5rem;
  }
`;
export const Title = styled.h1`
  margin: 0;
  font-family: "Rubik";
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 38px;
  text-align: start;
  color: #000000;
  margin-bottom: 0.5rem;

  @media (min-width: 992px) {
    font-size: 40px;
    line-height: 47px;
  }
`;

export const Subtitle = styled.p`
  font-family: "Rubik";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  margin: 0;
  color: #676767;
  margin-bottom: 3rem;

  @media (min-width: 992px) {
    font-size: 18px;
    line-height: 22px;
  }
`;
export const SvgIcon = styled.svg`
  width: 50px;
  height: 47.48px;

  opacity: ${({ scroll }) => (scroll > 1050 ? "1" : "0")};
  transition: opacity 0.5s ease-in-out;

  @media (min-width: 992px) {
    opacity: ${({ scroll }) => (scroll > 600 ? "1" : "0")};
    transition: opacity 0.9s ease-in-out;
  }
`;
